import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { Body, BodyBold } from 'styles/typography';
import ChatBubbleIcon from 'svg/ChatBubbleIcon';

type Props = { facility: string };

// The per-channel empty state (Figma "Chat — Empty State"): centered bubble glyph, a bold
// "No messages for {facility}", and a muted subline. The subline references a composer that
// lands in the messages story — v1 renders no composer.
export default function ChannelEmptyState({ facility }: Props) {
  return (
    <Panel data-testid='chat-empty-state'>
      <IconWrap aria-hidden>
        <ChatBubbleIcon width={44} height={44} />
      </IconWrap>
      <Title>No messages for {facility}</Title>
      <Subtitle>No messages yet. Send a note to {facility}’s team below.</Subtitle>
    </Panel>
  );
}

const Panel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  padding: 48px 24px;
`;

const IconWrap = styled.div`
  display: inline-flex;
  color: ${colors.black25};
  margin-bottom: 6px;
`;

const Title = styled(BodyBold)`
  color: ${colors.black75};
`;

const Subtitle = styled(Body)`
  color: ${colors.black50};
  max-width: 520px;
`;
